/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getUnreadCounts.defs'
export { main as default } from './getUnreadCounts.defs'
